import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createExpenseCategory,
  deleteExpenseCategory,
  listExpenseCategories,
  updateExpenseCategory,
  type ExpenseCategoryInput,
} from '../lib/expenseCategoriesApi';

const KEY = ['expense-categories'] as const;

export const EXPENSE_CATEGORIES_KEY = KEY;

/** `companyId` set → shared categories + that firm's; unset → all of them. */
export function useExpenseCategories(includeInactive = false, companyId?: string | null) {
  return useQuery({
    queryKey: [...KEY, includeInactive, companyId ?? null],
    queryFn: () => listExpenseCategories(includeInactive, companyId),
  });
}

export function useCreateExpenseCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ExpenseCategoryInput) => createExpenseCategory(input),
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateExpenseCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; input: ExpenseCategoryInput }) =>
      updateExpenseCategory(vars.id, vars.input),
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteExpenseCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteExpenseCategory(id),
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}
